import { useTranslation } from '@dreamstack/i18n'
import { SimpleDefinitionList } from '@dreamstack/simple-components/src/lib/SimpleDefinitionList'
import { cn } from '@dreamstack/util/src/cn'
import type { FullProject } from '@dreamstack/web/lib/prisma/projects'
import type { PropertyPreview } from '@dreamstack/web/lib/prisma/properties'
import filter from 'lodash/filter'
import type { FunctionComponent } from 'react'
import { useMinMaxOfProperties } from '../projects/helper/getMinMaxOfProperties'
import { ProjectInformationListBrochure } from './ProjectInformationListBrochure'

export const ProjectInformationList: FunctionComponent<
  React.PropsWithChildren<{
    properties: PropertyPreview[]
    project?: FullProject
  }>
> = ({ properties, project }) => {
  const t = useTranslation()

  const { rooms, sqm, maxRooms } = useMinMaxOfProperties({ properties })

  const constructionYear = !!properties
    ? (filter(
        properties,
        (p) => !!p.construction_year
      )[0]?.construction_year?.toString() ?? '-')
    : '-'

  return (
    <div
      className={cn(
        'grid grid-cols-5 py-px-24 mt-px-40 border-t-2 border-b-2 border-accentroWhite-full',
        'md:mt-px-32',
        'ml:py-px-32 ml:mt-px-32'
      )}
    >
      <div
        className={cn(
          'col-span-5 grid grid-cols-2 md:grid-cols-3 gap-y-px-24',
          'ml:grid-cols-5 ml:gap-y-px-32'
        )}
      >
        <SimpleDefinitionList
          big
          dt={rooms}
          dd={t('accentro:room.rooms', { count: maxRooms })}
        />
        <SimpleDefinitionList
          className="md:col-span-2"
          big
          dt={sqm}
          dd={t('accentro:livingSpace')}
        />
        <SimpleDefinitionList
          className="col-span-2 md:col-span-1"
          big
          dt={constructionYear}
          dd={t('accentro:yearOfConstruction')}
        />
        <ProjectInformationListBrochure project={project} />
      </div>
    </div>
  )
}
